import { FC } from "react";
import clsx from "clsx";

interface Props {
  label?: string;
  items: SelectOption[] | SelectOptionGroup[];
  value?: SelectOption;
  onChange?: (item: SelectOption) => void;
  error?: string;
  helpText?: string;
  touched?: boolean;
  id?: string;
  name?: string;
  cornerHint?: string;
}
export interface SelectOption {
  name: string;
  value: string;
}

export interface SelectOptionGroup {
  group: string;
  items: SelectOption[];
}

const Select: FC<Props> = ({
  label,
  items,
  value,
  cornerHint,
  onChange,
  error,
  helpText,
  touched,
  id,
  name,
}) => {
  const isGroup = Boolean((items[0] as SelectOptionGroup)?.group);

  return (
    <div>
      <div className="tw-flex tw-justify-between">
        {label && (
          <label
            htmlFor={name}
            className={clsx(
              "tw-block tw-text-sm tw-font-medium",
              error && touched ? "tw-text-red-500" : "tw-text-gray-700"
            )}
          >
            {label}
          </label>
        )}
        {cornerHint && (
          <span className="tw-text-sm tw-text-gray-500">Optional</span>
        )}
      </div>
      <div className="tw-mt-1">
        <select
          id={id}
          name={name}
          className="tw-block focus:tw-ring-indigo-500 focus:tw-border-indigo-500 tw-w-full tw-shadow-sm sm:tw-text-sm tw-border-gray-300 tw-rounded-md"
          onChange={(x) => {
            if (x) {
              onChange && onChange(JSON.parse(x.target.value) as SelectOption);
            }
          }}
        >
          <option value="">Seleccione</option>
          {isGroup ? (
            <>
              {(items as SelectOptionGroup[]).map((item) => (
                <optgroup key={item.group} label={item.group}>
                  {item.items.map((x, idx) => (
                    <option
                      value={JSON.stringify(x)}
                      key={`${idx} - ${x.name}`}
                      selected={x.value === value?.value}
                    >
                      {x.name}
                    </option>
                  ))}
                </optgroup>
              ))}
            </>
          ) : (
            <>
              {(items as SelectOption[]).map((item) => (
                <option
                  value={JSON.stringify(item)}
                  key={item.name}
                  selected={item.value === value?.value}
                >
                  {item.name}
                </option>
              ))}
            </>
          )}
        </select>

        {helpText && !error && (
          <p className="tw-text-left tw-mt-2 tw-text-xs tw-text-gray-500">
            {helpText}
          </p>
        )}
        {error && touched && (
          <p className="tw-text-left tw-mt-2 tw-text-xs tw-text-red-500">
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

export default Select;
